'use strict'

module.exports = normalize

// Normalize `value` with patterns.
function normalize(value, patterns) {
  var index = -1

  while (++index < patterns.length) {
    value = value.replace(patterns[index][0], patterns[index][1])
  }

  return value
}
